export default __webpack_public_path__ + "static/icon-4ec065b7b840ca91fd131d90ac95f5eb.png";